export default "__VITE_ASSET__EcI2ALmN__"